module.exports = __webpack_public_path__ + "img/012.680d4d76.png";